(function (t) {
t.fallback = 'en';
t.defaultDomain = 'messages';
})(Translator);
